import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { addCustomSpans } from '@atlaskit/react-ufo/interaction-metrics';
var mediaLabelStack = [{
  name: 'media'
}];
export var sendUfoDurationMetrics = function sendUfoDurationMetrics(ufoDurationMetrics, endpoint) {
  var labelStack = [].concat(mediaLabelStack, [{
    name: endpoint
  }]);
  Object.entries(ufoDurationMetrics).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      _ref2$ = _ref2[1],
      start = _ref2$.start,
      end = _ref2$.end,
      size = _ref2$.size;
    addCustomSpans(name, start, end, size, labelStack);
  });
};